module.exports = __webpack_public_path__ + "img/first.8af68e4e.png";